import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Denuncia } from 'src/app/dashboard/models/denuncia';
import { GestionExternaService } from 'src/app/dashboard/services/gestion-externa.service';
import { Abogado } from 'src/app/model/abogado';
import { CustomValidators } from 'src/app/shared/custom-validator/custom-validator.component';
import { ApiService } from 'src/app/shared/services/api.service';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-gestion-externa',
  templateUrl: './gestion-externa.component.html',
  styleUrls: ['./gestion-externa.component.css']
})
export class GestionExternaComponent implements OnInit {

  validatingForm: FormGroup;

  sociedad: string;
  abogados: Abogado[] = [];
  denuncias: Denuncia[] = [];
  nombreDenuncia = new Array();
  IsHiddenForm = false;

  constructor(
    private gestionExternaService: GestionExternaService,
    private router: Router,
    private auth: AuthService,
    private apiService: ApiService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    let language = this.auth.getLanguage() || 'es';
    this.translate.setDefaultLang(language);

    this.validatingForm = new FormGroup({
      signupFormModalName: new FormControl('', [
        Validators.required,
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ.,()\-_\[\]\/"']{2,255}$/), // control más estricto y amigable
        CustomValidators.secureInput
      ]),
      signupFormModalId: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9_-]{1,100}$/),
        CustomValidators.secureInput
      ]),
      contactFormModalMessage: new FormControl('', [
        Validators.maxLength(4000),
        CustomValidators.secureInput
      ]),
      signupFormModalEmail: new FormControl('', [
        Validators.email,
        Validators.maxLength(250),
        Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
      ])
    });

    this.sociedad = this.auth.getNameSociedad();
    this.apiService.searchLayerByUserSociety(this.auth.getSociedad()).subscribe({
      next: (response) => {
        if (response.code === 200 && response.success) {
          this.abogados = response.data || [];
          for (let i = 0; i < this.abogados.length; i++) {
            this.gestionExternaService
              .searchComplaintByUserSocietyID(this.auth.getSociedad(), '0', false, language)
              .subscribe((denuncia: Denuncia[]) => {
                this.denuncias = denuncia;
                this.nombreDenuncia.push(this.denuncias[0]?.nombre);
              });
          }
        }
      },
      error: (error) => {
        this.abogados = [];
        this.toastr.error(this.translate.instant('texto_894'), this.translate.instant('texto_813'));
      }
    });
  }

  showLayer(layer: Abogado) {
    let language = this.auth.getLanguage() || 'es';
    this.translate.setDefaultLang(language);
    this.IsHiddenForm = true;

    this.gestionExternaService
      .searchComplaintByUserSociety(this.auth.getSociedad(), language)
      .subscribe((denuncia: Denuncia[]) => {
        this.denuncias = denuncia;
      });

    this.validatingForm.patchValue({
      signupFormModalId: layer.id_abogado || '',
      signupFormModalName: layer.n_abogado || '',
      signupFormModalEmail: layer.email || '',
      contactFormModalMessage: layer.comentario || ''
    });
  }

  deleteLayer(id_abogado: string) {
    this.gestionExternaService.countComplaintByIdAbogados(this.auth.getSociedad(), id_abogado).subscribe(
      res => {
        if (res === 200) {
          this.gestionExternaService.deleteLayerByUser(this.auth.getSociedad(), id_abogado).subscribe(res => {
            if ((res as any).success === true) {
              this.toastr.success(this.translate.instant('texto_48'), this.translate.instant('texto_50'));
            } else {
              this.toastr.error(this.translate.instant('texto_49'), this.translate.instant('texto_50'));
            }
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/dashboard/layout/abogado']);
            });
          },
            err => {
              if (err.status === 409) {
                this.toastr.error(this.translate.instant('texto_49'), this.translate.instant('texto_813'));
              } else {
                this.toastr.error(this.translate.instant('texto_49'), this.translate.instant('texto_813'));
              }
            });
        } else {
          this.toastr.error(this.translate.instant('texto_49'), this.translate.instant('texto_50'));
          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/dashboard/layout/abogado']);
          });
        }
      },
      err => {
        this.toastr.error(this.translate.instant('texto_49'), this.translate.instant('texto_50'));
      }
    );
  }

  hideModal() {
    this.IsHiddenForm = false;
  }

  updateLayer(id_abogado: string) {
    if (this.validatingForm.invalid) {
      this.toastr.error(this.translate.instant('texto_815'), this.translate.instant('texto_813'));
      return;
    }

    const nombreAbogado = this.validatingForm.get('signupFormModalName').value;
    const comentario = this.validatingForm.get('contactFormModalMessage').value;
    const email = this.validatingForm.get('signupFormModalEmail').value;

    this.gestionExternaService
      .updateLayerByUser(this.auth.getSociedad(), id_abogado, '', nombreAbogado, comentario, email)
      .subscribe(
        res => {
          if ((res as any).success === true) {
            this.toastr.success(this.translate.instant('texto_52'), this.translate.instant('texto_51'));
          } else {
            this.toastr.error(this.translate.instant('texto_53'), this.translate.instant('texto_51'));
          }
          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/dashboard/layout/abogado']);
          });
        },
        err => {
          if (err.status === 409) {
            this.toastr.error(this.translate.instant('texto_53'), this.translate.instant('texto_813'));
          } else {
            this.toastr.error(this.translate.instant('texto_53'), this.translate.instant('texto_813'));
          }
        });
  }

  // Getters para facilitar el acceso a los campos en la plantilla
  get signupFormModalEmail() {
    return this.validatingForm.get('signupFormModalEmail');
  }

  get signupFormModalName() {
    return this.validatingForm.get('signupFormModalName');
  }

  get signupFormModalId() {
    return this.validatingForm.get('signupFormModalId');
  }

  get contactFormModalMessage() {
    return this.validatingForm.get('contactFormModalMessage');
  }

}
